//admin
import adminHome from '@/components/jm/admin/home.vue'
//app 版本管理
import appVersionsHome from '@/components/jm/admin/versions/home.vue'
import appVersionsList1 from '@/components/jm/admin/versions/list1.vue'
import appVersionsList2 from '@/components/jm/admin/versions/list2.vue'
import appVersionsAdd from '@/components/jm/admin/versions/add.vue'
import appVersionsUpdate from '@/components/jm/admin/versions/update.vue'


//人员管理
import appEmpHome from '@/components/jm/admin/emp/home.vue'
import appEmpList from '@/components/jm/admin/emp/list.vue'
import appEmpAdd from '@/components/jm/admin/emp/add.vue'
import appEmpUpdate from '@/components/jm/admin/emp/update.vue'

//公共数据管理
import commonalityHome from '@/components/jm/admin/commonality/home.vue'
import commonalityList from '@/components/jm/admin/commonality/list.vue'
import commonalityAdd from '@/components/jm/admin/commonality/add.vue'
import commonalityUpdate from '@/components/jm/admin/commonality/update.vue'

//公共文件管理
import commonalityFileHome from '@/components/jm/admin/commonalityFile/home.vue'
import commonalityFileList from '@/components/jm/admin/commonalityFile/list.vue'
import commonalityFileAdd from '@/components/jm/admin/commonalityFile/add.vue'
import commonalityFileUpdate from '@/components/jm/admin/commonalityFile/update.vue'

//权限模块
  //menu
import menuHome from '@/components/jm/admin/jurisdiction/menu/home.vue'
import menuList from '@/components/jm/admin/jurisdiction/menu/list.vue'
import menuAdd from '@/components/jm/admin/jurisdiction/menu/add.vue'
import menuUpdate from '@/components/jm/admin/jurisdiction/menu/update.vue'
  //role
import roleHome from '@/components/jm/admin/jurisdiction/role/home.vue'
import roleList from '@/components/jm/admin/jurisdiction/role/list.vue'
import roleAdd from '@/components/jm/admin/jurisdiction/role/add.vue'
import roleUpdate from '@/components/jm/admin/jurisdiction/role/update.vue'
  //新闻咨询
import xinwenzixunHome from '@/components/jm/admin/xinwenzixun/home.vue'
import xinwenzixunList from '@/components/jm/admin/xinwenzixun/list.vue'
import xinwenzixunAdd from '@/components/jm/admin/xinwenzixun/add.vue'
import xinwenzixunUpdate from '@/components/jm/admin/xinwenzixun/update.vue'
  //厂家信息
import manuHome from '@/components/jm/admin/manu/home.vue'
import manuList from '@/components/jm/admin/manu/list.vue'
import manuAdd from '@/components/jm/admin/manu/add.vue'
import manuUpdate from '@/components/jm/admin/manu/update.vue'
  //品牌管理
import brandHome from '@/components/jm/admin/brand/home.vue'
import brandList from '@/components/jm/admin/brand/list.vue'
import brandAdd from '@/components/jm/admin/brand/add.vue'
import brandUpdate from '@/components/jm/admin/brand/update.vue'
  //服务与设备交互日志
import macMessageLogHome from '@/components/jm/admin/macMessageLog/home.vue'
import macMessageLogList from '@/components/jm/admin/macMessageLog/list.vue'


//设备信息
import macHome from '@/components/jm/admin/mac/home.vue'
import macList from '@/components/jm/admin/mac/list.vue'
  //服务接口请求时间
import responseTimeHome from '@/components/jm/admin/responseTime/home.vue'
import responseTimeList from '@/components/jm/admin/responseTime/list.vue'
import responseTimeList1 from '@/components/jm/admin/responseTime/list1.vue'

//用户意见
import clientOpinionHome from '@/components/jm/admin/clientOpinion/home.vue'
import clientOpinionList from '@/components/jm/admin/clientOpinion/list.vue'
//加盟信息
import joinHome from '@/components/jm/admin/join/home.vue'
import joinList from '@/components/jm/admin/join/list.vue'
//工控机mac地址
import uuidHome from '@/components/jm/admin/uuid/home.vue'
import uuidList from '@/components/jm/admin/uuid/list.vue'
export default [{
	path: 'admin',
	name: 'admin',
	component: adminHome,
	children: [{ //工控机信息
			path: 'uuidHome',
			name: 'uuidHome',
			component: uuidHome,
			children: [{
				path: 'list',
				name: 'jm/admin/uuid/list',
				component: uuidList
			}]
		},{ //加盟信息
			path: 'joinHome',
			name: 'joinHome',
			component: joinHome,
			children: [{
				path: 'list',
				name: 'jm/admin/join/list',
				component: joinList
			}]
		},{ //服务接口请求时间
			path: 'clientOpinionHome',
			name: 'clientOpinionHome',
			component: clientOpinionHome,
			children: [{
				path: 'list',
				name: 'jm/admin/clientOpinion/list',
				component: clientOpinionList
			}]
		},{ //服务接口请求时间
			path: 'responseTimeHome',
			name: 'responseTimeHome',
			component: responseTimeHome,
			children: [{
				path: 'list',
				name: 'jm/admin/responseTime/list',
				component: responseTimeList
			},{
				path: 'list1',
				name: 'jm/admin/responseTime/list1',
				component: responseTimeList1
			}]
		},{ //设备信息
		path: 'macHome',
		name: 'macHome',
		component: macHome,
		children: [{
			path: 'list',
			name: 'jm/admin/mac/list',
			component: macList
		}]
	},{ //服务与设备交互日志
		path: 'macMessageLogHome',
		name: 'macMessageLogHome',
		component: macMessageLogHome,
		children: [{
			path: 'list',
			name: 'jm/admin/macMessageLog/list',
			component: macMessageLogList
		}]
	},{ //厂家信息
		path: 'manuHome',
		name: 'manuHome',
		component: manuHome,
		children: [{
			path: 'list',
			name: 'jm/admin/manu/list',
			component: manuList
		}, {
			path: 'add',
			name: 'jm/admin/manu/add',
			component: manuAdd
		}, {
			path: 'update',
			name: 'jm/admin/manu/update',
			component: manuUpdate
		}]
	},{ //品牌管理
		path: 'brandHome',
		name: 'brandHome',
		component: brandHome,
		children: [{
			path: 'list',
			name: 'jm/admin/brand/list',
			component: brandList
		}, {
			path: 'add',
			name: 'jm/admin/brand/add',
			component: brandAdd
		}, {
			path: 'update',
			name: 'jm/admin/brand/update',
			component: brandUpdate
		}]
	},{ //app版本管理
		path: 'appVersionsHome',
		name: 'appVersionsHome',
		component: appVersionsHome,
		children: [{
			path: 'list1',
			name: 'jm/admin/appVersions/list1',
			component: appVersionsList1
		},{
			path: 'list2',
			name: 'jm/admin/appVersions/list2',
			component: appVersionsList2
		}, {
			path: 'add',
			name: 'jm/admin/appVersions/add',
			component: appVersionsAdd
		}, {
			path: 'update',
			name: 'jm/admin/appVersions/update',
			component: appVersionsUpdate
		}]
	},{ //人员管理
		path: 'emp',
		name: 'emp',
		component: appEmpHome,
		children: [{
			path: 'list',
			name: 'jm/admin/emp/list',
			component: appEmpList
		}, {
			path: 'add',
			name: 'jm/admin/emp/add',
			component: appEmpAdd
		}, {
			path: 'update',
			name: 'jm/admin/emp/update',
			component: appEmpUpdate
		}]
	},{ //公共数据管理
		path: 'commonality',
		name: 'commonality',
		component: commonalityHome,
		children: [{
			path: 'list',
			name: 'jm/admin/commonality/list',
			component: commonalityList
		}, {
			path: 'add',
			name: 'jm/admin/commonality/add',
			component: commonalityAdd
		}, {
			path: 'update',
			name: 'jm/admin/commonality/update',
			component: commonalityUpdate
		}]
	},{ //公共文件管理
		path: 'commonalityFile',
		name: 'commonalityFile',
		component: commonalityFileHome,
		children: [{
			path: 'list',
			name: 'jm/admin/commonalityFile/list',
			component: commonalityFileList
		}, {
			path: 'add',
			name: 'jm/admin/commonalityFile/add',
			component: commonalityFileAdd
		}, {
			path: 'update',
			name: 'jm/admin/commonalityFile/update',
			component: commonalityFileUpdate
		}]
	},{ //权限管理:menu
		path: 'menu',
		name: 'menu',
		component: menuHome,
		children: [{
			path: 'list',
			name: 'jm/admin/menu/list',
			component: menuList
		}, {
			path: 'add',
			name: 'jm/admin/menu/add',
			component: menuAdd
		}, {
			path: 'update',
			name: 'jm/admin/menu/update',
			component: menuUpdate
		}]
	},,{ //权限管理:menu
		path: 'role',
		name: 'role',
		component: roleHome,
		children: [{
			path: 'list',
			name: 'jm/admin/role/list',
			component: roleList
		}, {
			path: 'add',
			name: 'jm/admin/role/add',
			component: roleAdd
		}, {
			path: 'update',
			name: 'jm/admin/role/update',
			component: roleUpdate
		}]
	},{ //新闻资讯
		path: 'xinwenzixun',
		name: 'xinwenzixun',
		component: xinwenzixunHome,
		children: [{
			path: 'list',
			name: 'jm/admin/xinwenzixun/list',
			component: xinwenzixunList
		}, {
			path: 'add',
			name: 'jm/admin/xinwenzixun/add',
			component: xinwenzixunAdd
		}, {
			path: 'update',
			name: 'jm/admin/xinwenzixun/update',
			component: xinwenzixunUpdate
		}]
	}]
}]



// WEBPACK FOOTER //
// ./src/router/jm/admin/admin.js